import DataTable from "react-data-table-component";
import React, { useEffect, useState } from "react";
import { ServiceData } from "../../../Services/Service";
import { Delete, Edit, PlusCircle } from "lucide-react";
import ConfirmDeleteDialog from "../../../View/ConfirDeleteDialog";

interface Entity {
  id?: number;
  nom: string;
}

const CrudPage: React.FC = () => {
  const [type, setType] = useState<"livreur" | "client" | "cooperative">("livreur");
  const [items, setItems] = useState<Entity[]>([]);
  const [form, setForm] = useState<Entity>({ nom: "" });
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [userToDelete,setUserToDelete]=useState<Entity | null>(null);

  const loadData = async () => {
    try {
      const res = await ServiceData(`/api/admin/list${type}`, "GET");
      if (Array.isArray(res)) {
        setItems(res);
        setError(null);
      }
    } catch (err: any) {
      setError(err.message || "Erreur lors du chargement.");
    }
  };

  useEffect(() => {
    loadData();
    setForm({ nom: "" });
    setIsEdit(false);
  }, [type]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.nom) {
      setError("Le champ nom est requis.");
      return;
    }

    try {
      if (isEdit && form.id) {
        await ServiceData(`/api/admin/edit${type}/${form.id}`, "PUT", form);
      } else {
        await ServiceData(`/api/admin/create${type}`, "POST", form);
      }

      setForm({ nom: "" });
      setIsEdit(false);
      loadData();
    } catch (err: any) {
      setError(err.message || "Erreur lors de l'enregistrement.");
    }
  };

  const DeleteUser = async () => {
    if(!userToDelete) return
      try {
        await ServiceData(`/api/admin/delete${type}/${userToDelete.id}`, "DELETE");
        loadData();
        setUserToDelete(null);
      } catch (err: any) {
        setError(err.message || "Erreur lors de la suppression.");
      }
    
  };


  const handleEdit = (item: Entity) => {
    setForm(item);
    setIsEdit(true);
  };

  const columns = [
    {
      name: "ID",
      selector: (row: Entity) => row.id ?? 0,
      sortable: true,
      width: "100px",
    },
    {
      name: "Nom",
      selector: (row: Entity) => row.nom,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row: Entity) => (
        <>
          <button className="btn btn-sm btn-outline-primary m-2" onClick={() => handleEdit(row)}>
            <Edit />
          </button>
          <button className="btn btn-sm btn-outline-danger" onClick={() => setUserToDelete(row)}>
            <Delete/>
          </button>
        </>
      ),
    },
  ];
  
  return (
  <>
    {userToDelete && (
      <ConfirmDeleteDialog
        user={userToDelete}
        error={error}
        onCancel={() => setUserToDelete(null)}
        onConfirm={DeleteUser}
      />
    )}

    <div className="p-1 max-w-4xl mx-auto">
      <h2 className="text-xl font-bold mb-4">Gestion des {type}s</h2>

      <div className="row g-2 align-items-center mb-3">
        <div className="col-md-4">
          <select
            className="form-select"
            value={type}
            onChange={(e) =>
              setType(e.target.value as "livreur" | "client" | "cooperative")
            }
          >
            <option value="livreur">Livreur</option>
            <option value="client">Client</option>
            <option value="cooperative">Coopérative</option>
          </select>
        </div>

        <div className="col-md-8">
          <form onSubmit={handleSubmit} className="d-flex align-items-center">
            <input
              type="text"
              value={form.nom}
              onChange={(e) => setForm({ ...form, nom: e.target.value })}
              placeholder={"Nom "+type}
              className="form-control"
            />
            <button
              type="submit"
              className="btn btn-outline-dark d-flex align-items-center ms-2"
              style={{ backgroundColor: "#1e3a8a", color: "white",border:"none",borderRadius:"6px" }}
            >
              {isEdit ? (
                <>
                  <Edit className="me-1" /> Modifier
                </>
              ) : (
                <>
                  <PlusCircle className="me-1" /> Créer
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      {error && <div className="text-danger mb-3">{error}</div>}

      <DataTable
        columns={columns}
        data={items}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
        noDataComponent="Aucune donnée disponible"
      />
    </div>
  </>
);

};

export default CrudPage;
